import React from 'react';
import { useObjectExtraFields } from '../useObjectExtraFields';
import { ExtraFieldsAreaContent, Loading } from './ExtraFieldsAreaContent';
import {
  ExtraFieldContextParam,
  ExtraFieldsFormIds,
  ExtraFieldsSupportedObject,
} from '../types';
import ExtraFieldsErrorBoundary from '../ExtraFieldsErrorBoundary';
import { ExtraFieldsError } from '../ExtraFieldsError';

export type Props = {
  objectApiName: ExtraFieldsSupportedObject;
  formId: ExtraFieldsFormIds;
  contextParams?: ExtraFieldContextParam[];
  disabled?: boolean;
  hideRecordType?: boolean;
  hideEmptyLookups?: boolean;
};

export const ExtraFieldsArea: React.FC<React.PropsWithChildren<Props>> = ({
  objectApiName,
  formId,
  contextParams,
  disabled,
  hideRecordType = false,
  hideEmptyLookups = false,
}) => {
  const { rawObjectExtraFields, getFormFields, loading, error } =
    useObjectExtraFields(objectApiName);

  const formFields = getFormFields(formId);

  if (loading) return <Loading />;
  if (error)
    return <ExtraFieldsError error={`Server error: ${error?.message}`} />;
  if (!rawObjectExtraFields) return null;
  const { availableRecordTypes } = rawObjectExtraFields;
  return (
    <ExtraFieldsErrorBoundary>
      <ExtraFieldsAreaContent
        contextParams={contextParams}
        availableRecordTypes={availableRecordTypes}
        formFields={formFields}
        disabled={disabled}
        hideRecordType={hideRecordType}
        hideEmptyLookups={hideEmptyLookups}
      />
    </ExtraFieldsErrorBoundary>
  );
};
